/* c8 ignore start */
/**
 * Thin, mockable seam around a full-page reload. Isolated in its own module so
 * that callers (lazyWithRetry, RouteErrorBoundary) can be unit-tested by mocking
 * this function — `window.location.reload` itself is non-configurable in jsdom
 * and cannot be spied on directly.
 */
export function reloadPage(): void {
  window.location.reload();
}
/* c8 ignore stop */
